import {combineReducers} from 'redux';

// reducers
import matchesReducer from './matches/reducer';
import dateTabsReducer from './dateTabs/reducer';
import sportFilterReducer from './sportFilter/reducer';
import teaserArticlesReducer from './teaserArticles/reducer';
import teaserWpArticlesReducer from './teaserWpArticles/reducer';
import tvProgramEventsReducer from './tvProgramEvents/reducer';
import matchDetailReducer from './matchDetail/reducer';
import competitionsReducer from './competitions/competitionsReducer';
import statsDataReducer from './statsData/reducer';
import competitionMatchesReducer from './competitionMatches/reducer';
import competitionTablesReducer from './competitionTables/reducer';
import matchLiveDataReducer from './live/reducer';
import timelineUpdateCmdsReducer from './timelineUpdateCmds/reducer';
import matchLineupsReducer from './lineups/reducer';
import betDataReducer from './betData/reducer';

/**
 * Merges all the reducers into one, well defined store
 */
export default combineReducers({
  // Matchcenter page-related reducers
  matches: matchesReducer,
  competitions: competitionsReducer,
  dateTabs: dateTabsReducer,
  sportFilter: sportFilterReducer,
  teaserArticles: teaserArticlesReducer,
  teaserWpArticles: teaserWpArticlesReducer,
  tvProgramEvents: tvProgramEventsReducer,
  // Match detail page-related reducers
  detail: matchDetailReducer,
  betData: betDataReducer,
  competitionMatches: competitionMatchesReducer,
  statsData: statsDataReducer,
  live: matchLiveDataReducer,
  timeline: timelineUpdateCmdsReducer,
  matchLineups: matchLineupsReducer,
  competitionTables: competitionTablesReducer,
});
